var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"w-full h-screen lg:pt-32 pt-6 container mx-auto flex flex-col lg:flex-col-reverse lg:justify-between"},[_c('NavLinks',{staticClass:"mb-12"}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }